import React, {type PropsWithChildren} from 'react';
import {HomeEnvContext, type HomeEnv} from './env';

export function HomeEnvProvider({value, children}: PropsWithChildren<{value: HomeEnv}>) {
  return <HomeEnvContext.Provider value={value}>{children}</HomeEnvContext.Provider>;
}
